export interface EmployeeAddressDto {
  StreetAddress?: string;
  ApartmentNumber?: string;
  City?: string;
  ZipCode?: string;
  State?: string;
  Country?: string;
  County?: string;
}
